import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IonButton, IonLabel, IonSpinner } from '@ionic/angular/standalone';

import {
  ButtonStyles,
  Expand,
  Fill,
} from 'src/app/interfaces/components/elements/Button';

import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [CommonModule, IonButton, IonLabel, IonSpinner],
})
export class ButtonComponent implements OnInit {
  @Output() action: EventEmitter<Function> = new EventEmitter();
  @Input() styles: ButtonStyles | undefined;
  @Input() text!: string;
  @Input() dots: boolean = false;

  private readonly defaultStyles: ButtonStyles = {
    color: '#ffffff',
    backgroundColor: 'var(--cinza-escuro)',
    fontSize: '0.875rem',
    fill: Fill.Solid,
    expand: Expand.InlineBlock,
  };

  constructor(public loaderService: LoaderService) {}

  ngOnInit() {
    this.styles = { ...this.defaultStyles, ...this.styles };
  }
}
